// Service Dependencies
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

// App Config data
import { AppSettings } from '../../../app.config';

// Rxjs
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { EngCodeSiteDTO } from '../../interfaces/IEngCodeSites';


@Injectable()
export class EngCodesSitesService {

  apiUrl: string;

  constructor(
    private http: HttpClient
  ) {
    this.apiUrl = AppSettings.API_PROD_ENDPOINT;
  }

  getFilteredEngCodesSites(
    { sharepointPath, mobility }: { sharepointPath: string, mobility: string } = { sharepointPath: '', mobility: '' }
  ): Observable<EngCodeSiteDTO[]> {

    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const requesttUrl = this.apiUrl + `db-eng-codes-sites/filter-by-sharepoint-path`;
    return this.http.post<EngCodeSiteDTO[]>(requesttUrl, { sharepointPath, mobility }, { headers })
      .pipe(
        map((response) => {

          response = response.map((engCodeSite) => {
            let canBeSelected = {
              value: true,
              reason: 'Is not assigned to any engagement'
            };

            if (engCodeSite.engCodes.length > 0) {
              if (engCodeSite.engCodes.some(engCode => engCode.project.mobility.id != Number(mobility))) {
                canBeSelected = {
                  value: false,
                  reason: 'Is assigned to another client'
                }
              } else {
                canBeSelected = {
                  value: true,
                  reason: 'Is only assigned to this client'
                };
              }
            }

            engCodeSite.canBeSelected = canBeSelected;

            return engCodeSite;

          })

          return response
        })
      )
  }

  hasSiteAsociated(engagementCode: string): Observable<{site: string}> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const requesttUrl = this.apiUrl + `db-eng-codes-sites/has-site-asociated`;
    return this.http.post<{site: string}>(requesttUrl, { engagementCode }, { headers })
  }

  getAsociatedSiteByMobility(mobilityId: number): Observable<any []> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const requesttUrl = this.apiUrl + `db-eng-codes-sites/get-asociated-site-by-mobility`;
    return this.http.post<EngCodeSiteDTO[]>(requesttUrl, { mobilityId }, { headers })
  }

}
